import { useQuery } from "@tanstack/react-query";
import useApi from "./useApi";

const useFeatureFlag = (key: string) => {
  const api = useApi();

  const { data: enabled = false } = useQuery({
    queryKey: ["feature-flag", key],
    queryFn: () => api.settings_Get(key),
    enabled: !!key,
  });

  return enabled;
};

export default useFeatureFlag;
